import { memo, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import CategoryCard from "./CategoriesCard";
import SwiperNavigationButton from "./CategoriesButtonNavigation";
import { FestivalCategory } from "@features/landing/types";

interface Props {
  isMobile: boolean;
  data?: FestivalCategory[];
  handleClear: () => void;
  handleSelect: (id: number) => void;
  activeCategoryId: number;
}

const CategoriesSwiper = ({
  isMobile,
  data = [],
  handleClear,
  handleSelect,
  activeCategoryId,
}: Props) => {
  const hasActiveCategory = Boolean(activeCategoryId);

  const spaceBetween = useMemo(() => (isMobile ? 8 : 16), [isMobile]);

  if (!data.length) return null;

  return (
    <div className="relative">
      <div className="max-w-full overflow-hidden">
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next-category",
            prevEl: ".swiper-button-prev-category",
            disabledClass: "opacity-0",
          }}
          slidesPerView="auto"
          loop
          centeredSlides
          slideToClickedSlide
          spaceBetween={spaceBetween}
          className="relative z-[2] px-5"
        >
          <SwiperSlide className="w-auto">
            <CategoryCard
              title="همه"
              isAll
              isActive={!hasActiveCategory}
              isMobile={isMobile}
              onClick={hasActiveCategory ? handleClear : undefined}
            />
          </SwiperSlide>

          {data.map(({ id, name, svg_image }) => {
            const isActive = activeCategoryId === id;

            return (
              <SwiperSlide key={id} className="w-auto">
                <CategoryCard
                  title={name}
                  image={svg_image}
                  isActive={isActive}
                  isMobile={isMobile}
                  onClick={!isActive ? () => handleSelect(id) : undefined}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>

      <SwiperNavigationButton direction="prev" />
      <SwiperNavigationButton direction="next" />
    </div>
  );
};

export default memo(CategoriesSwiper);
